<template>
  <footer
    id="theme-footer"
    v-observe-visibility="visibilityChanged"
    :class="[baseAnimation]"
    class="theme-footer"
  >
    <div class="bg-gray row top-footer padding_large">
      <router-link to="/">
        <WpImage
          v-if="footerLogo"
          :data="footerLogo"
          class="footer-image-logo"
        />
      </router-link>
      <div class="social-row">
        <span class="follow">Følg oss</span>
        <ul class="social-links">
          <li
            v-for="(link, i) in socialLinks"
            :key="i"
          >
            <a v-if="link && link != ''" role="social" target="_blank" :href="link">
              <StyledIcon
                iconsColor="#2A2E34"
                class="icon"
                :class="i"
                v-html="svgIcons[i]"
              />
            </a>
          </li>
        </ul>
      </div>
      <div class="row-content">
        <div class="main">
          <DynamicHtml v-if="footerText">{{ footerText }}</DynamicHtml>
          <WpNavi location="footer-menu" icons="true" />
        </div>
        <Newsletter v-if="newsletter" />
      </div>
    </div>
    <div v-if="footerRows" class="bg-dark row mid-footer padding_large">
      <div v-for="(row, i) in footerRows" :key="i" class="footer-row">
        <h4 class="footer-row-title">
          <WpLink
            v-if="row.row_title_link"
            class="link"
            :url="row.row_title_link"
            >{{ row.row_title }}</WpLink
          >
          <span v-else>{{ row.row_title }}</span>
          <StyledIcon iconsColor="#fff" class="icon" v-html="svgIcons.arrow2" />
        </h4>
        <ul v-if="row.footer_logos" class="footer-logos">
          <li v-for="(logo, k) in row.footer_logos" :key="k">
            <WpLink v-if="logo.logo_link" :url="logo.logo_link">
              <WpImage
                v-if="logo.logo_image"
                :data="logo.logo_image"
                class="image"
                :style="'margin-top:' + logo.margin_top + 'px'"
              />
            </WpLink>
            <WpImage
              v-else-if="logo.logo_image"
              :data="logo.logo_image"
              class="image"
              :style="'margin-top:' + logo.margin_top + 'px'"
            />
          </li>
        </ul>
      </div>
    </div>
    <div class="bg-gray row bot-footer">
      <div class="left">
        Copyright {{ new Date().getFullYear() }} Stiftelsen Skapia |
        <WpLink :url="privacyPolicy" title="Personvernerklæring"
          >Personvernerklæring</WpLink
        >
      </div>
      <div class="right">
        Levert av
        <a
          role="designer"
          class="designer"
          target="_blank"
          href="//tankenbak.no"
          >Tanken Bak</a
        >
      </div>
    </div>
  </footer>
</template>

<script>
import WpImage from "@/components/elements/WpImage";
import WpLink from "@/components/elements/WpLink";
//import AcfLink from "@/components/elements/AcfLink";
import StyledIcon from "@/components/elements/StyledIcon";
import WpNavi from "@/components/elements/WpNavi";
import Newsletter from "@/components/elements/Newsletter";

export default {
  name: "theme-footer",
  data() {
    return {
      privacyPolicy: WPVUE.privacy_policy,
      footerRows:
        WPVUE.options && WPVUE.options.footer_logos_row
          ? WPVUE.options.footer_logos_row
          : null,
      footerText: WPVUE.options.footer_text,
      footerLogo: WPVUE.options.page_logo_footer,
      socialLinks: WPVUE.options.social_links,
      newsletter: WPVUE.options.newsletter
    };
  },
  computed: {},
  components: {
    WpImage,
    WpLink,
    StyledIcon,
    WpNavi,
    Newsletter,
    //AcfLink
  }
};
</script>

<style lang="scss">
@import "./../assets/scss/mixins.scss";
@import "./../assets/scss/vars.scss";

.theme-footer {
  .html-content {
    white-space: pre-line;
  }
  .footer-image-logo {
    margin: 0;
    padding: 0;
    top: 25px;
    left: 25px;
    position: absolute;
    img {
      max-height: 32px;
    }
    @include mquery(767px) {
      left: 15px;
    }
  }
  .wp-navi-links {
    margin: 0;
    padding: 0;
    list-style: none;
    margin-top: 20px;
    svg g {
      fill: $purple !important;
    }
    li {
      display: inline-block;
      margin-right: 20px;
      a {
        color: inherit;
        font-weight: 700;
        text-decoration: none;
        span {
          margin-left: 10px;
          position: relative;
          top: 3px;
        }
      }
    }
  }
  .top-footer {
    position: relative;
    padding-top: 30px;
    .wp-navi-links {
      li {
        a {
          &:hover {
            color: #853376;
          }
        }
      }
    }
    .row-content {
      display: flex;
      flex-wrap: nowrap;
      @include mquery(991px) {
        flex-direction: column;
      }
      .main {
        padding-right: 150px;
        @include mquery(991px) {
          padding-right: 0;
          width: 100%;
        }
      }
    }
    .social-row {
      padding-bottom: 20px;
      margin-bottom: 25px;
      border-bottom: 1px solid rgba(#4a4f55, 0.25);
      display: flex;
      justify-content: flex-end;
      .follow {
        margin-right: 25px;
      }
      .social-links {
        margin: 0;
        padding: 0;
        list-style: none;
        li {
          display: inline-block;
        }
        .icon {
          margin-left: 10px;
        }
        svg {
          width: 24px;
          height: 24px;
        }
      }
    }
  }
  .mid-footer {
    color: #fff;
    .footer-row-title {
      border-bottom: 1px solid rgba(#fff, 0.25);
      font-weight: 700;
      margin: 0;
      margin-bottom: 20px;
      padding-bottom: 10px;
      a {
        color: inherit;
        text-decoration: none;
        &:hover {
          text-decoration: underline;
        }
      }
      .icon {
        margin-left: 10px;
        top: 3px;
        position: relative;
      }
    }
    .footer-row {
      margin-bottom: 50px;
      &:last-child {
        margin-bottom: 0;
      }
    }
    .footer-logos {
      list-style: none;
      display: flex;
      align-items: center;
      margin: 0 -12px;
      padding: -0;
      flex-wrap: wrap;
      @include mquery(1199px) {
        //flex-wrap: wrap;
        //justify-content: center;
      }
      li {
        padding: 12px;
        @include mquery(1199px) {
          img {
            max-width: 75%;
          }
        }
      }
      .image-hold {
        margin: 0;
      }
    }
  }

  .bot-footer {
    padding: 25px 50px;
    display: flex;
    font-size: 12px;
    @include font-smoothing(on);
    a {
      color: inherit;
    }
    .left {
    }
    .right {
      text-align: right;
      flex: 1 0 auto;
      a {
        text-decoration: none;
      }
    }
  }
}
</style>
